import {ValueObject} from '@s-ui/domain'

export default class VerifyAuthenticationValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Boolean} data.logged
   * */
}
